import React, { useState, useEffect } from "react";
import LoginPage from "./components/LoginPage";
import Dashboard from "./components/Dashboard";
import "./App.css";

export default function App() {
  const [token, setToken] = useState(null);

  // ✅ RESTORE TOKEN ON PAGE LOAD
  useEffect(() => {
    const savedToken = localStorage.getItem("auth_token");
    if (savedToken) {
      setToken(savedToken);
    }
  }, []);

  return (
    <div className="app-container">
      {!token ? (
        <LoginPage setToken={setToken} />
      ) : (
        <Dashboard token={token} setToken={setToken} />
      )}
    </div>
  );
}
